import './bootstrap';
import Vue from 'vue';
import vuetify from '../plugins/vuetify'; //UI framework
import router from './router'; //Vue Router
import store from './store'; //Vuex
import VueI18n from 'vue-i18n'; //Internationalization plugin
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import VueNativeSock from '@prazedotid/vue-native-websocket';
//main vue component
import App from './components/App';
import constants from 'Helpers/constants';
import utils from 'Helpers/utils';
import VueGtag from 'vue-gtag';
import VueDateFns from 'vue-date-fns';
// import LoadScript from 'vue-plugin-load-script';

//hide console.log for production
if (process.env.VUE_APP_ENV === 'production' && !JSON.parse(localStorage.getItem('app.showConsoleLog'))) {
    Vue.config.productionTip = false;
    Vue.config.devtools = false;

    console.log = function () {};
    console.warn = function () {};
    // console.error = function() {};
}

Vue.prototype.$const = constants;
Vue.prototype.utils = utils;

const uuid = uuidv4();
store.commit('setUniqAppId', uuid);

if (utils.getPlatform() === constants.PLATFORM_TRADEBALL) {
    store.dispatch('UserModule/restoreAuth');
}

//VueI18n settings
Vue.use(VueI18n);
// Vue.use(LoadScript);

function loadMessages() {
    const context = require.context('../locales', true, /[a-z0-9-_]+\.json$/i);

    const messages = context
        .keys()
        .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
        .reduce(
            (messages, { key, locale }) => ({
                ...messages,
                [locale]: context(key),
            }),
            {}
        );

    return { context, messages };
}
const { messages } = loadMessages();

// eslint-disable-next-line no-undef
let locale = serverOptions.locale;
if (utils.getPlatform() === constants.PLATFORM_TRADEBALL && window.localStorage.getItem('locale')) {
    //for tradeball need to get locale from localStorage, because player can change locale
    locale = window.localStorage.getItem('locale');
}

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages,
});
store.$i18n = i18n;

axios.interceptors.request.use(
    (request) => {
        let token = store.getters['UserModule/getToken'];
        if (token) {
            request.headers['Authorization'] = 'Bearer ' + token;
        }

        if (!request.params) {
            request.params = {};
        }

        request.params['uniqAppId'] = store.getters['getUniqAppId'];
        request.params['locale'] = window.localStorage.getItem('locale');
        return request;
    },
    (error) => {
        Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        let prevUrl = response.config.url;
        if (
            response.data.message &&
            !(
                prevUrl.includes('authenticate') ||
                prevUrl.includes('registration') ||
                prevUrl.includes('verify') ||
                prevUrl.includes('verify-email') ||
                prevUrl.includes('reset-password') ||
                prevUrl.includes('forgot-password') ||
                prevUrl.includes('logout') ||
                prevUrl.includes('uploadDocuments')
            )
        ) {
            let message;
            try {
                message = JSON.parse(response.data.message);
                for (let key in message[1]) {
                    message[1][key] = i18n.te(message[1][key]) ? i18n.t(message[1][key]) : message[1][key];
                }
            } catch (e) {
                message = response.data.message;
            }

            let msg = Array.isArray(message) ? i18n.t(message[0], message[1]) : i18n.t(message);

            response.data.success ? utils.successMessage(msg) : utils.failMessage(msg);
        }

        return response;
    },
    (error) => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                case 419:
                    store.dispatch('AuthModule/logout');
                    break;
                case 400:
                case 500:
                    utils.failMessage(error.response.statusText);
                    break;
            }
            return Promise.reject(error.response.data);
        }
    }
);
Vue.prototype.axios = axios;
Vue.prototype.router = router;

Vue.component('app', require('./components/App').default);

import dateFnsLocaleEn from 'date-fns/locale/en-US';
import dateFnsLocalePt from 'date-fns/locale/pt';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

let dateLocale = dateFnsLocaleEn;

if (locale === 'pt') {
    dateLocale = dateFnsLocalePt;
}

Vue.use(VueDateFns, 'dd MMM yyyy', { locale: dateLocale });

export const eventBus = new Vue();

Vue.filter('capitalizeFirstLetter', function (string) {
    return _.capitalize(string);
});

Vue.filter('capitalizeAllFirstLetter', function (string) {
    return _.startCase(_.toLower(string));
});

Vue.filter('formatInTimeZone', function (date, formatStr, withTimeZone, options) {
    let timeZone = 'Europe/London';
    if (withTimeZone === true) {
        let user = store.getters['UserModule/getUser'];
        if (user) {
            timeZone = user.timeZone;
        }
    }

    //if date instanceof Date, we assume that this date was created in JS in local time and no need to convert time to zonedTimeToUtc
    if (!(date instanceof Date)) {
        date = zonedTimeToUtc(date, 'Europe/London'); //'Europe/London' here is our DB timezone
    }

    options = Object.assign({ locale: dateLocale }, options);

    return formatInTimeZone(date, timeZone, formatStr, options);
});

// eslint-disable-next-line no-undef
let appName = serverOptions.appName;

Vue.use(
    VueGtag,
    {
        config: {
            id: process.env.VUE_APP_G_ANALYTICS_ID,
            linker: {
                // accept_incoming: true,
                domains: [
                    'bet-bra.com',
                    'apostasnow.com',
                    'apostasbf.com',
                    'drinbetzero.com',
                    'bolsadeaposta.com',
                    'greenwin.bet',
                    'betbox.bet',
                    'fulltbet.com',
                    'verdinhabet.com',
                    'oddjusta.com',
                ],
            },
        },
        appName: appName,
        pageTrackerScreenviewEnabled: true,
    },
    router
); //router here for auto tracking

//Vue instance
new Vue({
    el: '#app',
    render: (h) => h(App),
    vuetify,
    router,
    store,
    i18n,
});

Vue.use(VueNativeSock, '', {
    connectManually: true,
    reconnection: true, // (Boolean) whether to reconnect automatically (false)
    // reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
    // reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
    store: store,
    format: 'json',
});

let token = store.getters['UserModule/getToken'];
if (token) {
    Vue.prototype.$connect(utils.getWebSocketURL(token));
}
